/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { memo } from 'react';

import { useLocation } from 'js/lib/useRouter';

import { Typography2 } from '@coursera/cds-core';
import { CertificateIcon } from '@coursera/cds-icons';

import { carouselExperimentLocations } from 'bundles/collections-carousel/constants';

import _t from 'i18n!nls/product-card';

const styles = {
  reviews: css`
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  `,
  reviewItem: css`
    margin-right: 4px;
  `,
  reviewsBlue: () => css`
    display: flex;
    align-items: center;
    margin-bottom: 4px;

    && {
      color: var(--cds-color-blue-800);
    }
  `,
  reviewItemBlue: () => css`
    margin-right: 4px;

    && {
      color: var(--cds-color-blue-800);
    }
  `,
};

const ProductCardCredit = ({ showCreditOffered }: { showCreditOffered: boolean }) => {
  const location = useLocation();

  if (!showCreditOffered) {
    return null;
  }

  const textShouldBeBlue = carouselExperimentLocations.includes(location.pathname);

  return (
    <div css={textShouldBeBlue ? styles.reviewsBlue : styles.reviews}>
      <CertificateIcon css={textShouldBeBlue ? styles.reviewItemBlue : styles.reviewItem} color="support" />
      <Typography2
        component="p"
        variant="bodySecondary"
        color="supportText"
        css={textShouldBeBlue ? styles.reviewItemBlue : styles.reviewItem}
      >
        {_t('Credit offered')}
      </Typography2>
    </div>
  );
};

export default memo(ProductCardCredit);
